import { Component, TemplateRef, Input } from "@angular/core";

@Component({
	selector: "modal-frame",
	templateUrl: "./bp-modal-frame.component.html",
	styleUrls: ["./bp-modal-frame.component.scss"],
	standalone: false
})
export class BpModalFrameComponent {
	@Input()
	public templateRef: TemplateRef<Element>;
}
